<template lang="html">
  <div class="col-12">
    <template v-for="(question, index) in currentQuestions">
      <nps
        :key="question.id"
        v-if="question.type === 'NPS'"
        :question="question"
        class="align-middle"
      ></nps>
      <simple-text
        :key="question.id"
        v-if="question.type === 'TEXT'"
        :question="question"
      ></simple-text>
      <smiley
        :key="question.id"
        v-if="question.type === 'SMILEY'"
        :question="question"
        :order="client.order_smiley"
      ></smiley>
      <list
        :key="question.id"
        v-if="question.type === 'LIST'"
        :question="question"
      ></list>
      <check
        :key="question.id"
        v-if="question.type === 'CHECK'"
        :question="question"
      ></check>
      <radio
        :key="question.id"
        v-if="question.type === 'RADIO'"
        :question="question"
      ></radio>
      <numeral
        :key="question.id"
        v-if="question.type === 'NUMERAL'"
        :question="question"
      ></numeral>
      <personal
        :key="question.id"
        v-if="question.type === 'PERSONAL'"
        :question="question"
      ></personal>
    </template>
    <b-row>
      <b-col class="center-buttom-footer" align-self="start">
        <v-btn outline @click = "changeStepBack(-1)" v-if="activeStep != 0 && !completed" :style="{ color:client.color }" >
          <span class="">
            <i class="material-icons">
            arrow_back
            </i>
          </span>
        </v-btn>
      </b-col>

      <b-col class="center-buttom-footer" align-self="end">
        <v-btn outline @click="changeStep(1)" v-if="!completed" :disabled="validateNextStep" :style="{ color:client.color }">
          <span class="">
            <i class="material-icons">
            arrow_forward
            </i>
          </span>
        </v-btn>
      </b-col>

    </b-row>

  </div>
</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import Nps from '../components/Nps.vue';

import SimpleText from '../components/SimpleText.vue';
import Radio from '../components/Radio.vue';
import Check from '../components/Check.vue';
import Smiley from '../components/Smiley.vue';
import List from '../components/List.vue';
import Numeral from '../components/Numeral.vue';
import Personal from '../components/Personal.vue';


export default {
  components: {
    Nps,
    SimpleText,
    Radio,
    Check,
    Numeral,
    Smiley,
    List,
    Personal
  },
  props: {
    survey: {
      type: Object,
      required: true
    },
    client: {
      type: Object,
      required: true
    },
    device: {
      type: Object,
      required: true
    },
    tokenResponse: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      activeStep: 0,
      completed: false,
    };
  },
  
  computed: {
    currentStep: function () {
      return this.survey ? this.survey.steps[this.activeStep] : false;  
    },
    currentQuestions: function () {
      return this.currentStep ? this.currentStep.questions : null; 
    },
    validateNextStep: function () {
      if (this.currentQuestions) {
        for (let index = 0; index < this.currentQuestions.length; index++) {
          if (this.currentQuestions[index].type === 'NPS' && this.currentQuestions[index].value === null) {
            return true;
          }
          if (this.currentQuestions[index].type === 'CHECK' && this.currentQuestions[index].options_values.length === 0) {
            return true;
          }
          if (this.currentQuestions[index].type === 'RADIO' && this.currentQuestions[index].options_values.length === 0) {
            return true;
          }
          if (this.currentQuestions[index].type === 'LIST' && this.currentQuestions[index].value === null) {
            return true;
          }
          if (this.currentQuestions[index].type === 'NUMERAL' && this.currentQuestions[index].value === null) {
            return true;
          }
          if (this.currentQuestions[index].type === 'SMILEY' && this.currentQuestions[index].value === null) {
            return true;
          }

          if (this.currentQuestions[index].type === 'PERSONAL') {
            if (this.currentQuestions[index].required && !this.currentQuestions[index].value) {
              return true;
            }  
          }
        }
      }
      return false;
    }
  },
  methods: {
    changeStep (i) {
      this.saveResponse();
      this.activeStep += i;
      this.progressBar();
      if (this.activeStep === this.survey.steps.length) {
        this.completed = true;
        this.resetSurvey();
        if (this.survey.auto_refresh) {
          setTimeout(function () {
            this.activeStep = 0;
            this.completed = false;
          }.bind(this), 3000); 
        }
        
      }
    },
    changeStepBack (i) {
      this.activeStep += i;
      this.progressBar();
    },
    saveResponse () {
      let code = this.$route.query.code ? this.$route.query.code : null;
      let date = this.$route.query.date ? this.$route.query.date : null;
      
      let self = this;
      let coords = JSON.parse(localStorage.getItem('coords'));
      let latitude = coords.latitude;
      let longitude = coords.longitude;

      const payload = {
        questions: self.currentQuestions,
        round_id: self.survey.id,
        device_id: self.device.id,
        token: self.tokenResponse,
        latitude: latitude,
        longitude: longitude,
        code: code,
        date: date
      };

      let url = 'public/survey/device/store';
      axios.post(url, payload).then(response => {
      }).catch(error => {
        console.log(error);
      });
      
    },
    resetSurvey () {
      
      this.$emit('reset-survey', {
        'message_answered': this.survey.message_answered,
        'message_expired': this.survey.message_expired,
        'message_sub': this.survey.message_sub,
        'message_success': this.survey.message_success,
        'auto_refresh': this.survey.auto_refresh
      });
      /* Add delay because, clear values before saving */
      setTimeout(function () {
        
        this.survey.steps.forEach((step, index) => {
          step.questions.forEach(question => {
            question.value = null;
            question.option_id = null;
            question.options_values = [];
          });
        });
      }.bind(this), 2500);
      
      
    },
    progressBar () {
      this.$emit('update-progressbar', Math.round((this.activeStep / this.survey.steps.length) * 100));
    },
    generateUuid () {
      let value = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
      return value;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/surveys/componentSurveyDevices/SurveyStandard.vue